import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatAgentRole(role: string | null | undefined): string {
  const roleMap: Record<string, string> = {
    broker_of_record: "Broker of Record",
    managing_broker: "Managing Broker",
    broker_salesperson: "Broker Salesperson",
    salesperson: "Salesperson",
  };
  return roleMap[role || ""] || "Agent";
}

export const US_STATES = [
  { value: "NJ", label: "New Jersey" },
  { value: "PA", label: "Pennsylvania" },
  { value: "NY", label: "New York" },
  { value: "DE", label: "Delaware" },
  { value: "MD", label: "Maryland" },
  { value: "CT", label: "Connecticut" },
  { value: "VA", label: "Virginia" },
  { value: "FL", label: "Florida" },
  { value: "CA", label: "California" },
  { value: "TX", label: "Texas" },
] as const;
